import ConsultCard from "@/features/appointments/components/ConsultCard"
import { Appointment } from "@/features/appointments/types/Appointment"
import { useCreateEvent } from "@/features/events/hooks/useCreateEvent"
import { EventType as NewEventType } from "@/features/events/types/EventType"
import { ExpertGenderRole } from "@/features/experts/types/ExpertGenderRole"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { handleDayOfMonth, handleHourAndMinutes, handleMonthString } from "../../../utils/Functions"
import { saveEvent } from "../../../utils/apis/user-service"
import { EventType } from "../../../utils/enums/EventType"
import { useAuthStore } from "../../../utils/stores/useAuthStore"
import { useConsultsStore } from "../../../utils/stores/useConsultsStore"
import { useUserStore } from "../../../utils/stores/useUserStore"
import { ExpertRole } from "../../experts/types/ExpertRole"
import { useGetAppointments } from "../hooks/useGetAppointments"

const AppointmentsPage = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const { userData } = useUserStore()
    const email = userData.email
    const { consultsData } = useConsultsStore()
    const pastAppointments = consultsData.allPastAppointments ? [...consultsData.allPastAppointments].reverse() : [];
    const allFutureAppointments = consultsData.allFutureAppointments
    const navigate = useNavigate()

    const { refetch: refetchAppointments } = useGetAppointments()

    useEffect(() => {
        if (!email || !idToken) return
        saveEvent(
            email,
            EventType.PageView,
            (success) => { console.log() },
            (error) => { console.log(error) },
            "your_appointments_page",
        )

        void sendEvent({
            event: NewEventType.PAGE_VIEW,
            sub_category: "appointments_page",
        })
    }, [])

    useEffect(() => {
        refetchAppointments()
    }, [])

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            {
                allFutureAppointments !== null && allFutureAppointments.length > 0 ?
                    <div className="w-full flex-shrink-0">
                        <div className="font-bold text-[12px] leading-[20px]">Prossimi appuntamenti</div>
                        {
                            allFutureAppointments.map((appointment, index) => (
                                <ConsultCard key={index} appointment={appointment} />
                            ))
                        }
                    </div> :
                    <div>
                        Qui puoi trovare tutti gli appuntamenti che hai prenotato, passati e futuri.
                    </div>
            }
            {
                pastAppointments !== null && pastAppointments.length > 0 &&
                <div className="w-full mt-[20px]">
                    <div className="font-bold text-[12px] leading-[20px]">Appuntamenti passati</div>
                    {
                        pastAppointments.map((appointment, index) => (
                            <PastAppointmentCard key={index} appointment={appointment} />
                        ))
                    }
                </div>
            }
        </div>
    )
}

export default AppointmentsPage

interface Props {
    appointment: Appointment,
}

const PastAppointmentCard: React.FC<Props> = ({
    appointment,
}) => {
    return (
        <div className="w-full h-[178px] bg-[#F5F5F5] my-[10px] rounded-[15px] flex items-center justify-center">
            <div className="w-[90%] h-[70%] flex flex-col justify-between">
                <div className="font-bold text-[12px] leading-[20px]">Videoconsulto</div>
                <div className="font-normal text-[35px] leading-[35px] flex">
                    <div className="font-bold mr-[10px]">
                        {handleDayOfMonth(appointment.date)} {handleMonthString(appointment.date)}
                    </div>
                    <div>
                        {handleHourAndMinutes(appointment.date)}
                    </div>
                </div>
                <div className="w-full flex items-end justify-between">
                    <div className="font-bold text-[12px] leading-[20px]">
                        <div>
                            {appointment.expert?.data.sex ? ExpertGenderRole.Dottssa : ExpertGenderRole.Dott}
                        </div>
                        <div className="text-[20px]">
                            {appointment.expert?.data.name} {appointment.expert?.data.family_name}
                        </div>
                    </div>
                    <div className="font-bold text-[14px] leading-[20px] text-holifya-blue">
                        {appointment.expert?.role === ExpertRole.Nutritionist ? "Nutrizionista" : "Medico"}
                    </div>
                </div>
            </div>
        </div>
    )
}
